import { PlainDate } from '@/lib/date-time/PlainDate';
import spacetime from 'spacetime';
import { WorkPattern, WorkPatternOverride } from '../../api/v1';

export const isWorkingDay = (
  workPattern: WorkPattern,
  workPatternOverrides: WorkPatternOverride[],
  date: Date,
  timezone: string,
): boolean => {
  if (!workPattern && !workPatternOverrides.length) {
    return true;
  }
  const workPatternOverrideForDate = workPatternOverrides.find(
    (o) => o.date.toString() === PlainDate.fromDate(date, timezone).toString(),
  );
  if (workPatternOverrideForDate) {
    return workPatternOverrideForDate.isWorkingDay;
  }
  return !workPattern || workPattern.pattern[spacetime(date, timezone).day()];
};

export const isDayOff = (
  workPattern: WorkPattern,
  workPatternOverrides: WorkPatternOverride[],
  date: Date,
  timezone: string,
): boolean => {
  if (!workPattern && !workPatternOverrides.length) {
    return false;
  }
  const workPatternOverrideForDate = workPatternOverrides.find(
    (o) => o.date.toString() === PlainDate.fromDate(date, timezone).toString(),
  );
  if (workPatternOverrideForDate) {
    return !workPatternOverrideForDate.isWorkingDay;
  }
  return !!workPattern && !workPattern.pattern[spacetime(date, timezone).day()];
};
